import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productsApi } from "api/api/productsApi/productsApi";
import { CreateProductBody, CreateProductRes } from "api/api/productsApi/types";

export const createProduct = createAsyncThunk<
  CreateProductRes,
  CreateProductBody
>("products/createProduct", async (body, { rejectWithValue }) => {
  try {
    const data = await productsApi.createProduct(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while creating product", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while creating product", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
